import { useTranslation } from 'react-i18next';
import { Languages } from 'lucide-react';
import { Button } from '@/components/ui/button';

const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'ms' ? 'en' : 'ms';
    i18n.changeLanguage(newLang);
    localStorage.setItem('preferredLanguage', newLang);
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggleLanguage}
      className="flex items-center justify-center gap-2 w-full sm:w-auto"
    >
      <Languages className="w-4 h-4" />
      <span>{t('language.switchTo')}</span>
    </Button>
  );
};

export default LanguageSwitcher;
